import { apiWobaBackend } from "@/services/api-woba-backend";
import { GetBookingDownsellProps } from "./get-booking-downsell.types";

export const GetBookingDownsellApi = async ({
  id,
}: GetBookingDownsellProps) => {
  const { data } = await apiWobaBackend.get(`/bookings/downsell-details/${id}`);

  return data;
};
